import React from 'react'

const PaymentSlipPage = React.lazy(() => import('pages/PaymentSlip/PaymentSlipPage'));
const PaymentSlipAddPage = React.lazy(() => import('pages/PaymentSlip/PaymentSlipAddPage'));

const PaymentSlipRoutes = [
    {
        path: '/payment-slip',
        exact: true,
        name: 'Danh sách phiếu chi',
        function: 'SL_PAYMENTSLIP_VIEW',
        component: PaymentSlipPage,
    },
    {
        path: '/payment-slip/add',
        exact: true,
        name: 'Thêm mới phiếu chi',
        function: 'SL_PAYMENTSLIP_ADD',
        component: PaymentSlipAddPage,
    },
    {
        path: '/payment-slip/edit/:payment_slip_id',
        exact: true,
        name: 'Chỉnh sửa phiếu chi',
        function: 'SL_PAYMENTSLIP_EDIT',
        component: PaymentSlipAddPage,
    },
    {
        path: '/payment-slip/detail/:payment_slip_id',
        exact: true,
        name: 'Chi tiết phiếu chi',
        function: 'SL_PAYMENTSLIP_VIEW',
        component: PaymentSlipAddPage,
    },
]

export default PaymentSlipRoutes
